import React, { useEffect, useMemo, useState } from 'react';
import api from '../api';

const CATEGORIES = [
  { key: 'f', label: '비행기', thryField: 'fthrytime', pracField: 'fpractime' },
  { key: 'h', label: '회전익', thryField: 'hthrytime', pracField: 'hpractime' },
  { key: 'n', label: '항공전자', thryField: 'nthrytime', pracField: 'npractime' },
];

export default function SubjectManagement() {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    api.get('/admin/subjects').then((res) => setRows(res.data));
  }, []);

  const totals = useMemo(() => {
    const t = { fthrytime: 0, fpractime: 0, hthrytime: 0, hpractime: 0, nthrytime: 0, npractime: 0 };
    rows.forEach((r) => {
      t.fthrytime += r.fthrytime || 0;
      t.fpractime += r.fpractime || 0;
      t.hthrytime += r.hthrytime || 0;
      t.hpractime += r.hpractime || 0;
      t.nthrytime += r.nthrytime || 0;
      t.npractime += r.npractime || 0;
    });
    return t;
  }, [rows]);

  // 같은 과목(subject)이 연속되는 구간의 시작 행에만 rowSpan을 부여해 병합된 것처럼 보이게 한다.
  const subjectSpans = useMemo(() => {
    const spans = {};
    rows.forEach((r, i) => {
      if (i === 0 || rows[i - 1].subject !== r.subject) {
        let span = 1;
        while (i + span < rows.length && rows[i + span].subject === r.subject) span += 1;
        spans[i] = span;
      }
    });
    return spans;
  }, [rows]);

  return (
    <div className="page">
      <div className="page-header">
        <h2>항공정비사과정 지정기준</h2>
      </div>

      <div className="card">
        <div className="subject-curriculum-totals">
          {CATEGORIES.map((c) => (
            <div key={c.key} className="subject-curriculum-total-item">
              <span className="subject-curriculum-total-label">{c.label}</span>
              <span>학과 : {totals[c.thryField]}</span>
              <span>실기 : {totals[c.pracField]}</span>
            </div>
          ))}
        </div>

        <div className="subject-curriculum-source-note">※. 항공안전법 시행규칙 [별표12] 전문교육기관 지정기준</div>

        <div className="table-scroll">
          <table className="data-table subject-curriculum-table">
            <thead>
              <tr>
                <th rowSpan={2}>순번</th>
                <th rowSpan={2}>과목</th>
                <th rowSpan={2}>교육내용</th>
                {CATEGORIES.map((c) => (
                  <th key={c.key} colSpan={2}>{c.label}</th>
                ))}
                <th rowSpan={2}>비고</th>
              </tr>
              <tr>
                {CATEGORIES.map((c) => (
                  <React.Fragment key={c.key}>
                    <th>학과</th>
                    <th>실기</th>
                  </React.Fragment>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.map((r, i) => (
                <tr key={r.amtcode}>
                  <td>{i + 1}</td>
                  {subjectSpans[i] && (
                    <td rowSpan={subjectSpans[i]} className="subject-curriculum-subject-cell">
                      {r.subject}
                    </td>
                  )}
                  <td className="subject-curriculum-chapter">{r.chapter}</td>
                  <td>{r.fthrytime}</td>
                  <td>{r.fpractime}</td>
                  <td>{r.hthrytime}</td>
                  <td>{r.hpractime}</td>
                  <td>{r.nthrytime}</td>
                  <td>{r.npractime}</td>
                  <td className="subject-curriculum-remark">{r.remark}</td>
                </tr>
              ))}
              {rows.length === 0 && (
                <tr>
                  <td colSpan="10" className="empty-row">등록된 과목이 없습니다.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
